import { ParkingOption } from "@offstreetparking/design-system/dataDisplay/ParkingOption";
import { ResponsiveOverlay } from "../../../overlays/ResponsiveOverlay";
import type { WizardParkingChoice } from "../../PermitContextProvider/types";
import { LocationButtonList } from "../LocationButtonList";

type LocationSelectionOverlayProps = {
	isOpen: boolean;
	onOpenChange: (open: boolean) => void;
	optionName: string;
	title: string;
	timezone: string;
	permitIntervals: WizardParkingChoice["time"]["intervals"];
	locations: WizardParkingChoice["locations"];
	onLocationClick: (locationId: number) => void;
	isInstant?: boolean;
	context?: WizardParkingChoice["context"];
};

export const LocationSelectionOverlay = ({
	isOpen,
	onOpenChange,
	optionName,
	title,
	timezone,
	permitIntervals,
	locations,
	onLocationClick,
	isInstant = false,
	context,
}: LocationSelectionOverlayProps) => {
	return (
		<ResponsiveOverlay isOpen={isOpen} onOpenChange={onOpenChange} title={title} description={optionName}>
			<div className="space-y-4">
				<ParkingOption
					timezone={timezone}
					permitIntervals={permitIntervals}
					isInstant={isInstant}
					context={context}
				/>

				<div className="-mx-4 h-[5px] bg-neutral-faded" />

				<LocationButtonList locations={locations} variant="default" onLocationClick={onLocationClick} />
			</div>
		</ResponsiveOverlay>
	);
};
